import React from 'react'
import styles from './Footer.module.scss'
import IconFb from 'assets/icons/socialMedia/icon-facebook.svg'
import IconTw from 'assets/icons/socialMedia/icon-twiter.svg'
import IconIg from 'assets/icons/socialMedia/icon-instargam.svg'
import IconLi from 'assets/icons/socialMedia/icon-line.svg'
import { Row, Col } from 'antd'
import ReactGA from 'react-ga'
import { TranslateLanguage } from 'util/Translate'
import { vocabFooter } from 'util/Translate.variable'

const translate = new TranslateLanguage()
translate.addMaping(vocabFooter)
const infoAppColumn = [
  {
    text: translate.convert('แพ็กเกจ & ราคา'),
    key: 'package',
  }
]
const infoLawColumn = [
  {
    text: translate.convert('เงื่อนไขและข้อตกลงในการใช้งาน'),
    key: 'term-condition',
  },
  {
    text: translate.convert('นโยบายความเป็นส่วนตัว'),
    key: 'privacy-policy',
  }
]
const infoSupportColumn = [
  {
    text: translate.convert('ติดต่อเรา'),
    key: 'contact',
  }
]


const Footer = (props) => {
  const sendGAEvent = (name) => {
    ReactGA.event({
      category: 'Footer',
      action: 'Click Menu footer',
      label: name
    })
  }
  return (
    <div className={styles.divRoot}>
      <div className={styles.divImg} />
      <div className={styles.divPadding}>
        <div className={styles.divSiteMap}>
          <Row>
            <Col span={6}>
              <span className={styles.title}>{translate.convert('ข้อมูล')}</span>
              {
                infoAppColumn.map((info) => {
                  return (
                    <span key={info.key} className={styles.list} onClick={() => {
                      sendGAEvent(info.key)
                      props.props.history.push(`/${info.key}`)
                    }} >
                      {info.text}
                    </span>
                  )
                })
              }
            </Col>
            <Col span={6}>
              <span className={styles.title}>{translate.convert('ข้อมูลทางกฎหมาย')}</span>
              {
                infoLawColumn.map((info) => {
                  return (
                    <span key={info.key} className={styles.list} onClick={() => {
                      sendGAEvent(info.key)
                      props.props.history.push(`/${info.key}`)
                    }} >
                      {info.text}
                    </span>
                  )
                })
              }
            </Col>
            <Col span={6}>
              <span className={styles.title}>{translate.convert('ช่วยเหลือ')}</span>
              {
                infoSupportColumn.map((info) => {
                  return (
                    <span key={info.key} className={styles.list} onClick={() => {
                      sendGAEvent(info.key)
                      props.props.history.push(`/${info.key}`)
                    }} >
                      {info.text}
                    </span>
                  )
                })
              }
            </Col>
            <Col span={6}>
              <span className={styles.title}>{translate.convert('ช่องทางรับข่าวสาร')}</span>
              <span className={styles.listSocial}>
                <div className={styles.Oval} onClick={() => { sendGAEvent('facebook'); window.open('https://www.facebook.com/sobtidjunior', '_blank') }}>
                  <img alt='IconFb' src={IconFb} className={styles.imgIcon} />
                </div>
                <div className={styles.Oval} onClick={() => { sendGAEvent('twitter'); window.open('https://twitter.com/sobtidme?s=21', '_blank') }}>
                  <img alt='IconTw' src={IconTw} className={styles.imgIcon} />
                </div>
                <div className={styles.Oval} onClick={() => { sendGAEvent('instagram'); window.open('https://www.instagram.com/sobtidjunior/', '_blank') }}>
                  <img alt='IconIg' src={IconIg} className={styles.imgIcon} />
                </div>
                <div className={styles.Oval} onClick={() => { sendGAEvent('line'); window.open('https://lin.ee/HxYePHg', '_blank') }}>
                  <img alt='IconLi' src={IconLi} className={styles.imgIcon} />
                </div>
              </span>
            </Col>
          </Row>
          <div style={{ marginTop: 24 }}>
            <span style={{ color: '#00913d', fontSize: 12 }}>Copyright © {new Date().getFullYear()} Sobtid Edutainment Co., Ltd. All rights reserved.</span>
          </div>

        </div>
        <div className={styles.divCopyRight}>
          <div>
            <span className={styles.copyRight}>Sobtid Edutainment Co., Ltd. products</span>
          </div>
          <div className={styles.sobtidLink}>
            <span onClick={() => { sendGAEvent('junior-landing'); window.open('https://sobtid.me/kid', '_blank') }}>สอบติด : จูเนียร์</span>
            <span onClick={() => { sendGAEvent('admission-landing'); window.open('https://sobtid.me/admission', '_blank') }}>สอบติด : Admission</span>
            <span onClick={() => { sendGAEvent('gov-landing'); window.open('https://sobtid.me/gov', '_blank') }}>สอบติด : ข้าราชการ</span>
          </div>
        </div>
      </div>

    </div>
  )
}
export default Footer